import { useState, useContext, useEffect, useCallback } from "react";
import { MainContext } from "../../context/main-context";
import { datasetType } from "../../interface-type";
import { getDatasetList, getLayerList, getRequestsList } from "../../api/andaman/vallaris";
import { getCustomers } from '../../api/andaman'
import { replaceAll } from "../use-func/util";

export const UseDatasetListA = () => {
    const [datasetlist, setdatasetlist] = useState<datasetType[] | null>(null)
    const { hostA, tokenA, hostV } = useContext(MainContext);
    const loadData = useCallback(async () => {

        const rsDataset = await getDatasetList(hostA, tokenA);
        const customer = await getCustomers(hostA, tokenA)
        if (rsDataset.length === 0) {
            setdatasetlist(new Array());
        } else if (rsDataset.length > 0) {
            const output = rsDataset.map((ds: any) => {
                return {
                    id: replaceAll(ds.dataset_name, " ", "-"),
                    url: [`${hostV}/tile/${ds.dataset_id}/{z}/{x}/{y}?key=${customer[0].vallaris.api_key}`],
                    sourceLayer: ds.dataset_id,
                    style: ds.dataset_style[0]
                };
            });
            setdatasetlist(output);
        } else {
            setdatasetlist(rsDataset)
        }
    }, [setdatasetlist]);
    useEffect(() => {
        if (!datasetlist && tokenA) {
            loadData();
        }
    }, [datasetlist, tokenA]);

    return datasetlist;
}

export const UseMapservice = () => {
    const [mapservices, setmapservices] = useState<object[] | null>(null);
    const { hostA, tokenA } = useContext(MainContext);

    const loadMs = useCallback(async () => {
        let fullMsLayer = new Array();
        const mapserviceLayer = await getLayerList(
            hostA,
            tokenA,
        );
        if (mapserviceLayer.length) {
            const promisLayers = await mapserviceLayer.map((layer: any) => {
                return getRequestsList(hostA,
                    tokenA, layer.layer_id);
            });
            const reqLayers = await Promise.all(promisLayers);
            await reqLayers.map((rl: any) => {

                const getMapRqList = rl.filter(
                    (r: any) =>
                        r.request_type === "GET_MAPTILE" || r.request_type === "GET_MAP"
                );
                const layer = mapserviceLayer.find(
                    (l: any) => l.layer_id === getMapRqList[0].layer_id
                );
                fullMsLayer.push({
                    ...layer,
                    request: getMapRqList.length ? getMapRqList[0] : null
                });
                return rl;
            });
        }

        setmapservices(fullMsLayer);
    }, []);

    useEffect(() => {
        if (!mapservices) {
            loadMs();
        }
    }, [mapservices, loadMs]);

    return mapservices;
}